const getters = {
  scMeasureUnits: state => state.sc_measure_units,
  scMeasureUnit: state => state.sc_measure_unit,
  scMeasureUnitFilters: state => state.sc_measure_unit_filters,
}

export default getters;
